import initializeSkipToContent from '../Entries/skipToContentEntry';
import initializeApplication from '../Entries/mainApplicationEntry';
import initializeApplicationHelper from '../Entries/helperEntry';
import initializeSearchMask from '../Entries/searchMaskEntry';
import initializeUtilities from '../Entries/utilitiesEntry';
import initializeSlider from '../Entries/sliderEntry';
import initializeOfferGallery from '../Entries/offerGalleryEntry';
import initializeHeroSlider from "../Entries/heroSliderEntry";
import initializeTabs from '../Entries/tabsEntry';
import initializeRating from "../Entries/ratingEntry";
import initializeRatingMobile from "../Entries/ratingMobileEntry";
import initializeSunRating from "../Entries/sunRatingEntry";
import initializeNavigation from "../Entries/navigationEntry";
import initializeBurgerMenu from "../Entries/burgerMenuEntry";
import initializeNewsletter from "../Entries/newsletterEntry";
import initializePRGLink from "../Entries/prgLinkEntry";
import initializeCountdown from "../Entries/countdownEntry";
import initializeLanguageSwitcherLinks from "../Entries/languageSwitcherEntry";
import initializeNewsletterExtended from "../Entries/newsletterExtendedEntry";
import initializeAnimatedBox from "../Entries/animatedBoxEntry";
import initializeTextFlexible from "Entries/textFlexibleEntry";
import initializeHotelDetailBookmarkHeart from "../Entries/hotelDetailBookmarkHeartEntry";
import initializeGame from "../Entries/gameEntry";
import initializeWeather from "../Entries/weatherEntry";
import initializeClimate from "../Entries/climateEntry";
import initializeTabRow from "../Entries/tabRowEntry";
import initializeUlmDestinationlist from "../Entries/ulmDestionlistEntry";
import initializeGoogleMaps2 from "Entries/googleMaps2Entry";
import initializeDestinationCard from "Entries/destinationCardEntry";
var loginEntryPromise = import('../Entries/loginEntry');
document.addEventListener('DOMContentLoaded', function () {
    document.body.className += ' loaded';
    initializeLanguageSwitcherLinks();
    initializeApplication();
    initializeBurgerMenu();
    initializeNavigation();
    initializeSearchMask(true);
    initializeUtilities();
    initializeOfferGallery();
    initializeHeroSlider();
    initializeTabs();
    initializeNewsletter();
    initializeNewsletterExtended();
    initializeCountdown();
    initializeRating();
    initializeRatingMobile();
    initializeSunRating();
    initializeHotelDetailBookmarkHeart();
    initializeGame();
    initializeWeather();
    initializeClimate();
    initializeGoogleMaps2();
    initializeDestinationCard();
    initializeTabRow();
    initializeUlmDestinationlist();
    initializeSkipToContent('homepage', 'onetrust-banner-sdk');
    loginEntryPromise.then(function (module) { return setTimeout(function () { return module.default(); }, 0); });
});
window.addEventListener('load', function () {
    initializeApplicationHelper();
    initializeLanguageSwitcherLinks();
    initializeSlider();
    setTimeout(function () {
        initializePRGLink();
        initializeTextFlexible();
        initializeAnimatedBox();
    }, 500);
});
if ((typeof (document.getElementById('control-arrow')) != 'undefined' && document.getElementById('control-arrow') != null) && (typeof (document.getElementById('headline')) != 'undefined' && document.getElementById('headline') != null)) {
    document.getElementById('control-arrow').addEventListener("click", function () {
        window.scrollTo({
            top: document.getElementById('headline').getBoundingClientRect().top - 100,
            behavior: 'smooth'
        });
    });
}
window.sessionStorage.removeItem('destination-list-sorting');
window.sessionStorage.removeItem('hotel-list-sorting');
